import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking / not loaded
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("ne_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ne_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const applyAuth = (data) => {
    localStorage.setItem("ne_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return applyAuth(data);
  };
  const login = async (payload) => {
    const { data } = await api.post("/auth/login", payload);
    return applyAuth(data);
  };
  const adminLogin = async (payload) => {
    const { data } = await api.post("/auth/admin/login", payload);
    return applyAuth(data);
  };
  const logout = () => {
    localStorage.removeItem("ne_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, register, login, adminLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
